export default __webpack_public_path__ + "static/media/95.c9c865c4.gif";